<div class="p-grid">
  <div class="main-content">
    <h3>Dokumente</h3>

    <ng-container *ngIf="!dataLoaded">
      <div class="skeleton-container">
        <p-skeleton *ngFor="let i of [].constructor(10); index as idx" width="100%" height="3rem"></p-skeleton>
      </div>
    </ng-container>
    @if (voucherTypeData | async; as voucherTypeStyles) {
    <p-table *ngIf="dataLoaded" [value]="documents" [paginator]="true" [rows]="20" [rowsPerPageOptions]="[10, 20, 50]"
      [responsiveLayout]="'stack'" [style]="{ width: '100%' }" styleClass="documents-table" sortField="createdAt"
      [sortOrder]="-1" [customSort]="true" (sortFunction)="customSort($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Anzeige von Eintrag {first} bis {last} von insgesamt {totalRecords} Dokumenten">
      <!-- HEADER -->
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="voucherType">
            <p-sortIcon field="voucherType"></p-sortIcon>
            Typ
            <p-columnFilter field="voucherType" type="text" matchMode="equals" display="menu" showMatchModes="false"
              showAddButton="false" hideOnClear="true" showOperator="false" showApplyButton="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [options]="voucherTypeOptions" placeholder="Typ auswählen" optionLabel="label"
                  optionValue="value" scrollHeight="500px" (onChange)="filter($event.value)" appendTo="body">
                  <ng-template pTemplate="item" let-opt>
                    <i [class]="opt.icon" [ngStyle]="{
                        color: opt.color,
                        'margin-right': '0.5rem'
                      }"></i>
                    {{ opt.label }}
                  </ng-template>

                  <ng-template pTemplate="selectedItem" let-opt>
                    <i [class]="opt.icon" [ngStyle]="{
                        color: opt?.color || '#000',
                        'margin-right': '0.5rem'
                      }"></i>
                    {{ opt?.label || "Typ auswählen" }}
                  </ng-template>
                </p-dropdown>
              </ng-template>
            </p-columnFilter>
          </th>

          <th pSortableColumn="userName">
            <p-sortIcon field="userName"></p-sortIcon>
            Teilnehmer:in
            <p-columnFilter field="userName" placeholder="Teilnehmer suchen" type="text" matchMode="contains"
              display="menu" showMatchModes="false" showAddButton="false" hideOnClear="true" showOperator="false">
            </p-columnFilter>
          </th>

          <th pSortableColumn="titel">
            <p-sortIcon field="titel"></p-sortIcon>
            Titel
            <p-columnFilter field="titel" placeholder="Titel suchen" type="text" matchMode="contains" display="menu"
              showMatchModes="false" showAddButton="false" hideOnClear="true" showOperator="false">
            </p-columnFilter>
          </th>

          <th>Datei</th>

          <th pSortableColumn="freitext">
            Text
            <p-columnFilter field="freitext" placeholder="Text suchen" type="text" matchMode="contains" display="menu"
              showMatchModes="false" showAddButton="false" hideOnClear="true" showOperator="false">
            </p-columnFilter>
          </th>

          <th pSortableColumn="createdAt">
            <p-sortIcon field="createdAt"></p-sortIcon>
            Erstellt
          </th>
        </tr>
      </ng-template>

      <!-- BODY -->
      <ng-template pTemplate="body" let-doc>
        <tr>
          <!-- Typ -->
          <td>
            <i [class]="getTypeStyle(voucherTypeStyles,doc.voucherType).icon" [ngStyle]="{
                color: getTypeStyle(voucherTypeStyles,doc.voucherType).color,
                'margin-right': '0.5rem'
              }" [pTooltip]="getTypeStyle(voucherTypeStyles,doc.voucherType).label" tooltipPosition="top"></i>
          </td>

          <!-- Teilnehmer -->
          <td>
            <div class="user-info">
              <div class="user-avatar" [ngStyle]="{
                  'background-color': getUserColor(doc.userName)
                }">
                {{ getInitials(doc.userName) }}
              </div>
              <span class="in-charge">
                {{ doc.userName }}
              </span>
            </div>
          </td>

          <!-- Titel -->
          <td [pTooltip]="doc.titel" tooltipPosition="top">
            {{ doc.titel }}
          </td>

          <!-- Datei -->
          <td>
            <a [href]="doc.fileUrl" target="_blank">
              <i class="pi pi-file-pdf"></i>
            </a>
          </td>

          <!-- Text -->
          <td class="text-col">
            <span class="text-preview" [pTooltip]="getPlainText(doc.freitext)" tooltipPosition="top">
              {{ getShortText(doc.freitext) }}
            </span>
          </td>

          <!-- Erstellt -->
          <td>
            {{ doc.createdAt | date : "dd.MM.yyyy HH:mm" }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    }
  </div>
</div>